import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css'
import 'mdb-react-ui-kit/dist/mdb-react-ui-kit'
import 'mdb-react-ui-kit/dist/mdb-react-ui-kit.esm'
import App from './App';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <App />

);